/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const oneOffPaymentNoticeDeleteRequestSchema = z.object({
  date: z.string(),
  reference: z.string(),
});
